import React from "react";
import WishlistButton from "./WishlistButton";
function acessories(){
    return ( 
        <div className="Accessories"> 
        <div className ="card">
    <div className="catalog-section-title"><h1>Samsung Headset</h1></div>
    <div className="row">

        <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body">
<img src={process.env.PUBLIC_URL + "/images/accessoriesimages/Samsung Level U Bluetooth Headset grey.jpeg"}alt="" />
   </div>
   <div className="card-header">
<h6>Samsung Level U Bluetooth Headset</h6>
<p>Grey, Wireless in the ear</p>
<h4> ₹2,499 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

      <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/accessoriesimages/Samsung Level U Bluetooth Headset blue.jpeg"}alt=""  /></div>
   <div className="card-header"><h6>Samsung Level U Bluetooth Headset</h6><p>Blue, Wireless in the ear</p><h4> ₹2,499 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>
    
      <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/accessoriesimages/Samsung Level U Bluetooth Headset gold.jpeg"}alt=""  /></div>
   <div className="card-header"><h6>Samsung Level U Bluetooth Headset</h6><p>Gold, Wireless in the ear</p><h4> ₹2,499 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>
    </div>
    </div>


    <div className ="card">
    <div className="catalog-section-title"><h1>Redmi Headset</h1></div>
    <div className="row">

      <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/accessoriesimages/Mi Basic Wired Headset with Mic red.jpeg"}alt=""  /></div>
   <div className="card-header"><h6>Mi Basic Wired Headset with Mic</h6><p>(Red, Wired in the ear)</p><h4> ₹399 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>
   
   <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/accessoriesimages/Mi Basic Wired Headset with Mic black.jpeg"}alt=""  /></div>
   <div className="card-header"><h6>Mi Basic Wired Headset with Mic</h6><p>(Black, Wired in the ear)</p><h4> ₹399 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

    <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/accessoriesimages/Mi Neckband Bluetooth Headset black.jpeg"}alt=""  /></div>
   <div className="card-header"><h6>Mi Neckband Bluetooth Headset </h6><p>(Black, Wired in the ear)</p><h4> ₹1599 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>
   </div>
    </div>


<div className ="card">
    <div className="catalog-section-title"><h1>Mobile Chargers</h1></div>
    <div className="row">

     <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/accessoriesimages/Samsung TA20IW Fast 1 A Mobile Charger.jpeg"}alt=""  /></div>
   <div className="card-header"><h6>Samsung TA20IW Fast 1 A Mobile Charger </h6><p>Samsung TA20IW Fast 1 A Mobile Charger with Detachable Cable  (White)</p><h4> ₹1,079 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

     <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/accessoriesimages/Samsung EP-TA20IWECGIN Type C Mobile Charger.jpeg"} alt="" /></div>
   <div className="card-header"><h6>Samsung EP-TA20IWECGIN Type C Mobile Charger </h6><p>Samsung EP-TA20IWECGIN Type C Mobile Charger with Detachable Cable  (White)</p><h4> ₹1,079 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

     <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/accessoriesimages/Samsung EP-TA845XBNGIN 3 A Multiport Mobile Charger.jpeg"} alt="" /></div>
   <div className="card-header"><h6>Samsung EP-TA845XBNGIN 3 A Multiport Mobile Charger</h6><p>Samsung EP-TA845XBNGIN 3 A Multiport Mobile Charger with Detachable Cable  (Black)</p><h4> ₹1,799 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

      <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/accessoriesimages/Ambrane ACM-1 1m 1 m Micro USB Cable.jpeg"} alt="" /></div>
   <div className="card-header"><h6>Ambrane ACM-1 1m 1 m Micro USB Cable </h6><p>Ambrane ACM-1 1m 1 m Micro USB Cable  (Compatible with Tablets, Mobiles, Black, One Cable)</p><h4> ₹179 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

     <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/accessoriesimages/boAt Micro USB 500 Black 1.5m 1.5 m Micro USB Cable.jpeg"}alt=""  /></div>
   <div className="card-header"><h6>boAt Micro USB 500 Black 1.5m 1.5 m Micro USB Cable </h6><p>boAt Micro USB 500 Black 1.5m 1.5 m Micro USB Cable  (Compatible with All Micro USB Supported Devices, Black, One Cable)</p><h4> ₹299 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

      <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/accessoriesimages/M SJV41541N SJV4116IN 1.2 m Micro USB Cable.jpeg"} alt="" /></div>
   <div className="card-header"><h6>Mi SJV41541N/SJV4116IN 1.2 m Micro USB Cable </h6><p>Mi SJV41541N/SJV4116IN 1.2 m Micro USB Cable  (Compatible with Android and Other Micro USB Supported Devices, Black, One Cable)</p><h4> ₹229 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

      <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/accessoriesimages/Philips DLP9041 10 WWireless Charger.jpeg"} alt="" /></div>
   <div className="card-header"><h6>Philips DLP9041 10 WWireless Charger</h6><p>Philips DLP9041 10 WWireless Charger with Micro USB Cable Charging Pad</p><h4> ₹1,799 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

      <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/accessoriesimages/Samsung EP-N5105TBEGIN Fast Charge.jpeg"} alt="" /></div>
   <div className="card-header"><h6>Samsung EP-N5105TBEGIN Fast Charge</h6><p>Samsung EP-N5105TBEGIN Fast Charge With Fan Cooling Charging Pad</p><h4> ₹4,199</h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>
    
      <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/accessoriesimages/Philips DLP9041 10 WWireless Charger.jpeg"}alt=""  /></div>
   <div className="card-header"><h6>Philips DLP9052 10 WWireless Charger</h6><p>Philips DLP9052 10 WWireless Charger with Micro USB Cable Charging Pad</p><h4> ₹2,499 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

     <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/accessoriesimages/LECO Video Ring Light for Photography.jpeg"} alt="" /></div>
   <div className="card-header"><h6>LECO Video Ring Light for Photography</h6><p>LECO Video Ring Light for Photography, Video Shooting, Streaming, TIK Tok Compatible with Camera, Android and iOS Devices Ring Flash  (Assorted)</p><h4> ₹1,299 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

     <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/accessoriesimages/Mindmaker Dimmable LED Studio Camera Ring.jpeg"} alt="" /></div>
   <div className="card-header"><h6>Mindmaker Dimmable LED Studio Camera Ring</h6><p>Mindmaker Dimmable LED Studio Camera Ring Light Photo Phone Video Light Lamp For Tripods Selfie Stick Ring Fill Light Ring Flash  (White, Black)</p><h4> ₹1,799 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>
    
     <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/accessoriesimages/CHG Big LED Ring Light with Tripod for Camera.jpeg"} alt="" /></div>
   <div className="card-header"><h6>CHG Big LED Ring Light with Tripod for Camera</h6><p>CHG Big LED Ring Light with Tripod for Camera Smartphone to Capture Photo and Video with 3 Mode Light Ring Flash (Black, Silver) Ring Flash  (White, Black)</p><h4> ₹2,799 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>
    </div>
    </div>
   
</div>)
}


export default acessories;